// Política de Privacidade — o TEXTO não mora mais aqui.
//
// A política canônica é `landing/public/privacidade/index.html`, HTML estático
// servido pelo Cloudflare Pages em https://windmaps.app/privacidade. Esta rota
// virou só o salto pra lá.
//
// Por que mudou (02/09/2026): a política era este componente React, e no
// navegador de um humano renderizava perfeitamente — por isso parecia certa. Mas
// o que o SERVIDOR entregava nesta URL eram 702 bytes com `<div id="root"></div>`
// e nenhuma palavra do texto; a página só nascia depois que o JS rodava. Quem
// busca a URL sem executar JS via uma página vazia, e foi isso que o Google Play
// reportou: DOIS itens bloqueando o envio pra review — "Privacy policy page
// returns a page not found error" e "Account deletion page returns a page not
// found error" (o segundo aponta pra âncora #excluir-conta, na mesma página).
//
// Regra que fica: URL que uma LOJA ou um CRAWLER precisa ler entrega o texto no
// HTML, sem depender de JS no cliente. Vale pros Termos de Uso também, que
// continuam com o mesmo defeito (`Terms.tsx`) — não flagrados porque nenhuma
// loja os varre, mas o dia em que uma varrer, o sintoma é este.
//
// O salto de verdade é o **301 no `infra/caddy/prod.Caddyfile`**: é ele que o
// crawler segue, porque crawler não executa o `location.replace` abaixo. Este
// componente cobre o caso que nunca chega ao Caddy: navegação interna do SPA
// (`<Link to="/privacy">` no Login e os `<a href="/privacy">` do Terms), que o
// react-router resolve no cliente sem pedir nada ao servidor.

import { useEffect } from 'react';

const PRIVACY_URL = 'https://windmaps.app/privacidade';

export function PrivacyPage() {
  // `hash` preservado porque `/privacy#excluir-conta` é a URL de exclusão de
  // conta declarada na ficha do Play: quem chegar por ela tem que cair NA seção,
  // não no topo do documento.
  const target = PRIVACY_URL + (window.location.hash || '');

  useEffect(() => {
    // `replace` e não `assign`: sem isso o botão "voltar" traz de volta pra esta
    // rota, que salta de novo — o usuário fica preso no documento.
    window.location.replace(target);
  }, [target]);

  return (
    <article className="container mx-auto max-w-3xl py-12">
      <p className="text-sm text-muted-foreground">
        A Política de Privacidade do WindMaps agora fica em{' '}
        <a href={target} className="underline">
          {PRIVACY_URL}
        </a>
        .
      </p>
    </article>
  );
}
